import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import config from '../../../../../../config'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
export default class FailedLoad extends Component {
    static propTypes = {
        block: PropTypes.string,
        customCallback: PropTypes.func,
        customText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        id: PropTypes.string,
        level: PropTypes.string,
        loadBlockData: PropTypes.func,
        module: PropTypes.string,
        show: PropTypes.bool,
        style: PropTypes.object,
    }

    static defaultProps = {
        show: false,
    }

    onRefreshBtnClickHandler = () => {
        const { block, module, id, level, loadBlockData } = this.props

        loadBlockData(module, id, block, level)
    }

    render() {
        const { show, customCallback, customText, style } = this.props

        if (!show) return null

        return (
            <div className={'workspace-failed-to-load'} style={{ ...style }}>
                <div className={'text-container'}>
                    {customText || <FormattedMessage id={`${LOCALE_PREFIX}.failedToLoad`} />}
                </div>
                <button className={'refresh-btn'} onClick={customCallback || this.onRefreshBtnClickHandler}>
                    {config.components.block.refreshButton && <FormattedMessage id={`${LOCALE_PREFIX}.refresh`} />}
                </button>
            </div>
        )
    }
}
